export default "__VITE_ASSET__PA5cdWwz__"